import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GainsUiCommonsModule } from '@gainsystems/gains-ui-commons';
import { Router, RouterModule } from '@angular/router';
import { AuthService } from './services/auth/auth.service';
import { environment } from '../environments/environment';
import { Title } from '@angular/platform-browser';
import { FeatureFlagsService } from './shared/services/feature-flags/feature-flags.service';
import { FEATURE_FLAG_DEO_AGENT } from './shared/services/feature-flags/feature-flags.constants';
import { Subscription } from 'rxjs';
import { AiAgentModule } from './shared/screens/deo-ai-assistant/deo-ai-assistant.module';
import { GainsSharedModule } from './shared/modules/gains-shared.module';

@Component({
  selector: 'app-root',
  imports: [CommonModule, GainsUiCommonsModule, GainsSharedModule, RouterModule, AiAgentModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit, OnDestroy {
  authServiceReady = false;
  isOnDeoAiAssist = false;
  isDeoAgentEnabled = false;
  private readonly featureFlagsSubscription?: Subscription;

  constructor(
    public authService: AuthService,
    private readonly _titleService: Title,
    private readonly router: Router,
    private readonly _featureFlagsService: FeatureFlagsService
  ) {
    this.authService.ready.then(() => {
      this.authServiceReady = true;
    });

    // Subscribe to feature flags to cache DEO Agent value
    this.featureFlagsSubscription = this._featureFlagsService.featureFlags$.subscribe(() => {
      this.isDeoAgentEnabled = this._featureFlagsService.isFeatureEnabled(FEATURE_FLAG_DEO_AGENT);
    });
  }

  ngOnInit(): void {
    // Set browser tab title based on environment
    this._titleService.setTitle(environment.envName);

    this.router.events.subscribe(() => {
      this.isOnDeoAiAssist = this.router.url.includes('/deo-ai-assist');
    });
  }

  ngOnDestroy(): void {
    this.featureFlagsSubscription?.unsubscribe();
  }
}
